import { useQuery } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';
import { useUserCompaniesState } from '../../../state/user-companies-state';
import type { ListPendingProjectTransfersResponse } from './pending-project-transfer-types';

/**
 * Fetches pending project transfers for all companies the signed-in user is admin for.
 * The API returns transfers for companies where the user is admin; the client filters by companyId when viewing a single company.
 */
export function usePendingProjectTransfersQuery() {
  const { isCompaniesLoaded } = useUserCompaniesState();

  return useQuery({
    queryKey: ['pending-project-transfers'],
    enabled: isCompaniesLoaded(),
    queryFn: async (): Promise<ListPendingProjectTransfersResponse> => {
      const companyService = SkyMapAxiosServiceFactory.instance.createCompanyServiceV1();
      const response = await companyService.getProjectTransferRequests({
        query: { include: ['company', 'user', 'project'] },
      });
      return { data: response.data ?? [] };
    },
  });
}
